import { memo, useRef } from 'react';
import { Modal, ModalBody, ModalContent, ModalOverlay } from '@chakra-ui/react';

import { usePageScrollLock } from 'shared/hooks';
import IconButton from 'shared/IconButton';

const CustomModal = ({ isOpen, onClose, children }) => {
  usePageScrollLock(isOpen);
  const initialRef = useRef(null);

  return (
    <Modal blockScrollOnMount={true} isOpen={isOpen} onClose={onClose} initialFocusRef={initialRef}>
      <ModalOverlay w="100vw" h="100vh" bgColor="rgba(0, 0, 0, 0.8)" />

      <ModalContent
        h="full"
        maxW="1440px"
        p={{ mobile: '16px', tablet: '18px', xxl: '40px' }}
        m="0"
        bgColor="unset"
        boxShadow="none"
        justifyContent={{ tablet: 'center' }}
        onClick={onClose}
      >
        <ModalBody
          w="full"
          h={{ tablet: 'full' }}
          maxH={{ mobile: 'full', tablet: 'fit-content' }}
          p="0"
          pos="relative"
          display="flex"
          flexDirection={{ mobile: 'column-reverse', tablet: 'row' }}
          alignItems={{ mobile: 'end', tablet: 'start' }}
          justifyContent="center"
          gap={{ mobile: '12px', tablet: '16px', laptop: '24px' }}
        >
          {/* Элемент-призрак чтобы сбить focus при открытие модалки и не было непроизвольного скролла к кнопке */}
          <span
            ref={initialRef}
            tabIndex={-1}
            style={{ position: 'absolute', opacity: 0, pointerEvents: 'none' }}
          />

          {children}

          <IconButton
            direction="cross"
            boxSize={{ mobile: '40px', xxl: '72px' }}
            iconProps={{ boxSize: { mobile: '20px', xxl: '32px' } }}
            bgColor="bg.white"
            border="none"
            flexShrink="0"
            onClick={onClose}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default memo(CustomModal);
